import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import {LoginRequest, LoginResponse} from '../models/auth.model';

@Injectable({
  providedIn: 'root',
})
export class AuthHttpService {
  private http = inject(HttpClient);
  private API_HOST = environment.API_HOST;

  login(req: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.API_HOST}/company/auth/login`, req);
  }
}
